import React, { PropTypes } from 'react'
import FullDatePicker from '../../form/FullDatePicker'
import Input from '../../form/Input'
import ImageUpload from '../../form/ImageUpload'
import { VideoInput } from '../../form/VideoInput'

import RichEditor from '../../form/RichEditor/index'

import CompetitionResult from './../CompetitionResult';

import RaisedButton from 'material-ui/RaisedButton'
import { Container, Row, Col } from 'react-grid-system'
import LoggedAppBar from '../../LoggedLayout/LoggedAppBar'
import IconButton from 'material-ui/IconButton'
import IconClose from '../../Icons/IconClose'
import config from 'config'

export default class CompetitionsEditForm extends React.Component {
  static propTypes = {
    fetch: PropTypes.func,
    title: PropTypes.string.isRequired,
    goIndex: PropTypes.func.isRequired,
    model: PropTypes.object,
    isNew: PropTypes.any,
    save: PropTypes.func.isRequired,
    publish: PropTypes.func.isRequired,
  };

  state = {}

  componentWillMount() {
    let { params: { id } = {}, fetch } = this.props || {};
    if (fetch) fetch(id)
  }

  componentWillUnmount() {
    let { onClose } = this.props;
    if(onClose) onClose()
  }

  async processSubmit() {
    return (
      this.props
        .handleSubmit(data => this.props.save(this.props.model, data))(this.props.values)
        .then(() => this.onClose())
        // eslint-disable-next-line no-console
        .catch(() => this.onClose())
    );
    
  }

  onClose() {
    
    let { goIndex } = this.props;
    if(goIndex) goIndex()
    
  }

  _renderHeader() {
    let { title } = this.props;

    return (
      <LoggedAppBar
        isStatic={true}
        title={title}
        iconElementRight={
          <IconButton onClick={() => this.onClose()}>
            <IconClose />
          </IconButton>
        }
      />
    );
  }
  _checkStartTime(startDate) {
    // let {fields: {status, statusType}} = this.props;
    let now = new Date();
    if (startDate.value) {
      return now > startDate.value
    }
  }
  render() {
    let {
      isNew,

      fields: { name, image, description, start_time, end_time, number_of_winners, video },
      submitting,
      disabled,
      valid,
    } = this.props;

    const datesDisabled = disabled || submitting
    disabled = disabled || submitting || this._checkStartTime(end_time)
    
    return (
      <Container style={{ margin: 0, padding: 30 }}>
        <form onSubmit={() => this.processSubmit()}>
          {this._renderHeader()}
          <Row>
            <Col lg={8} md={10} xs={12}>
            <Row>
              <Col xs={12}>
                <Input label="Add Competition Title" required
                  disabled={ disabled }
                  {...name} />
              </Col>
              <Col xs={12}>
                <VideoInput
                  label='Video'
                  allowedFormats={config.allowedFormats}
                  screenShotImageSize={config.streamCrop}
                  onScreenShotImage={async (screenShot) => {
                    image.onChange(screenShot);
                  }}
                  size="3GB"
                  disabled={ disabled }
                  {...video}/>
              </Col>
              <Col xs={12}>
                <ImageUpload
                  label="Competition Preview Picture"
                  required
                  imageWidth='auto'
                  imageHeight='300px'
                  disabled={ disabled }
                  crop={config.streamCrop}
                  {...image}
                />
              </Col>
              <Col xs={12}>
                <RichEditor
                  label="Add Description Text"
                  required
                  disabled={ disabled }
                  {...description}
                />
              </Col>
              <Col xs={12}>
                <Input
                  type={'number'}
                  label="Number of winners"
                  required
                  min={1}
                  disabled={ disabled }
                  {...number_of_winners}
                />
              </Col>
              <Row>
                <Col xs={12} style={{ margin: 0, padding: 30 }}>
                    <FullDatePicker
                      label="Start time"
                      required
                      min={new Date()}
                      disabled={ datesDisabled }
                      {...start_time}
                    />
                    <FullDatePicker
                      label="End time"
                      required
                      min={start_time.value}
                      disabled={ datesDisabled }
                      {...end_time}
                    />
                  </Col>
                </Row>
              </Row>
              <Row>
                <Col xs={12} style={{ display: 'flex'}}>
                    <RaisedButton
                      label={'Save'}
                      style={{ display: 'flex', flex: 1 }}
                      primary={true}
                      disabled={ disabled || !valid }
                      onClick={() => this.processSubmit()}
                    />
                    {/* <RaisedButton
                      label={'Save and Publish'}
                      style={{ display: 'flex', flex: 1, marginLeft: 16 }}
                      primary={true}
                      disabled={ disabled || !valid || this._checkStartTime(start_time) }
                      onClick={() => this.processSubmit()}
                    /> */}
                </Col>
              </Row>
            </Col>
          </Row>
          {isNew ? null : (
            <Container>
                <CompetitionResult />
            </Container>
          )}
        </form>
      </Container>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Competitions/CompetitionsEditForm/CompetitionsEditForm.jsx